/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Badoo - Magtagpo ng Mga Tao, Magchat, Humalubilo",
      "Maling numero ng telepono",
      "Get the app",
      "Magpatuloy sa Apple",
      "Magpatuloy sa Facebook",
      "Magpatuloy sa Google",
      "Log in",
      "Magsign up",
      "Para magpatuloy, pakipasok ang mga karakter na nakikita mo sa input field.",
      "Ipagpatuloy",
      "Ipasok ang mga titik",
      "Pagsiyasat ng Seguridad",
      "Reload",
      "Lumikha ng bagong password na kung saan madali ninyong maalaala:",
      "I-update",
      "Kompirmahin ang password",
      "Ang Password ay dapat di bababa sa {{num}} [[characters:num]]",
      "Password",
      "Gumawa ng bagong password",
      "Badoo - Ang Blog",
      "Karera",
      "Chat",
      "Mga lungsod",
      "I-manage ang cookies",
      "Copyright © 2006 – kasalukuyan. Bumble. Lahat ng karapatan ay nakalaan.",
      "Ang Apple at ang Apple logo ay mga trademark ng Apple Inc.{{__EOL__}}Ang Google Play ay isang trademark ng Google LLC.",
      "I-download",
      "Facebook",
      "Sundan kami",
      "Sentro ng Tulong",
      "Instagram",
      "Wika",
      "LinkedIn",
      "Overview",
      "Badoo ay bahagi ng Bumble Inc.",
      "Patakaran ng palihim",
      "Safety Centre",
      "Sitemap",
      "Pahayag ng Modern Slavery Act",
      "Mga takda at mga kondisyon",
      "Twitter",
      "Itala ang iyong email o numero ng mobile at padadalhan ka namin ng mga tagubilin sa paggawa ng bagong password.",
      "Kumuha ng bagong password",
      "Itala ang iyong email o numero ng telepono",
      "Nakalimutan ang password",
      "Mga modelong ginamit para sa mga layuning pang-ilustrasyon lamang",
      "Get the app",
      "We’re excited to bring renewed support, helpful technology, and safer experiences to help foster relationships formed with greater confidence. This is all part of Badoo’s commitment to being the app that builds dating confidence.",
      "We’ll continue to pioneer dating technology to meet the needs of daters as identified in this report, starting with the release of ‘<b><a href=\"{{url}}\">Deception Detector™</a></b>’, a machine learning model that has demonstrated <b>99.5% precision</b> in combating spam, scam and fake accounts.",
      "We remain <b>committed</b> to the responsible use of Artificial Intelligence (A.I.), ensuring human intelligence comes first and A.I. capabilities don’t damage the <b>authenticity</b> of our community;",
      "We’ll no longer contribute to the creation of dating trends that fuel <b>negative perceptions</b> and <b>behaviours</b>;",
      "We’ll work to identify <b>bad behaviour</b> in dating so we can minimise its impact on our community’s well-being;",
      "We’ll only work with influencer talent who we think are <b>authentic</b> and <b>realistic</b> in how they present themselves online;",
      "Take me to Badoo",
      "Our Confidence Commitments:",
      "We’ve published this report for daters, dating communities, and online platforms—anyone—to be able to use the findings to help people have a kinder, more enjoyable experience with greater possibilities than ever before.",
      "At Badoo, we know there’s work to be done. Our teams have studied findings and are making changes so we can play our part. But there are also immediate commitments we’ve decided to make.",
      "At a pivotal moment when we believe human connection has never been more valuable, and people having confidence in how they can form connections has never been more important, we have created an <b>industry first Dating Confidence Report.</b>",
      "Download the report",
      "Badoo has always been a pioneer in dating, creating one of the first online dating platforms in the world and being the first to reach 100 million downloads.",
      "The report details behaviours, attitudes and influences that have negatively influenced dating, supported by expert guidance on how we can enjoy more of the best parts—and be better equipped to manage (or change) the parts we’d all rather avoid.",
      "Being intentional: relaxing, being present, and being themselves in their dating experiences—on and offline",
      "Being able to ignore what they see on social media, and focus on what works for them;",
      "Feeling they can trust that who they’re seeing or speaking to is for real;",
      "Feeling clear in their own intentions and trusting that their matches are being genuine, too;",
      "Reducing paranoia and hypervigilance about negative dating behaviour;",
      "The key ingredients for greater dating confidence are:",
      "We believe this is the dating world’s biggest barrier to its potential—and our commitment to breaking this barrier has begun. Every year, instead of focusing on dating trends, we’ll track our own progress in building dating confidence and continue to assess the challenges daters face across the industry.",
      "The findings will lead to annual Confidence Commitments and innovations in our product to help minimise dating experiences that damage people’s confidence. Ultimately this’ll help make online dating a kinder, <b><u><a href=\"{{url}}\">safer</a></u></b> and more valuable experience for those who want meaningful connections. Our commitments for 2024 are below.",
      "Read Confidence Commitments",
      "The report shows us in no uncertain terms that dating confidence is at an all-time low for many singles.",
      "Hindi mo kailangang maghintay ng pares.{{__EOL__}}{{__EOL__}}Lumubog sa mga chat na mas may lalim, at makarating agad sa mga mahahalagang bagay. Alam mo 'yun, 'yung bahagi kung saan talagang nakakilala kayo nang husto sa isa't isa.",
      "Handang magchat ngayon?",
      "Sa pag-sign up, sang-ayon ka sa aming <a class=\"link\" href=\"{{terms_url}}\">Mga Takda at Kondisyon</a>. Aralin paano namin ginagamit ang data mo sa aming <a class=\"link\" href=\"{{privacy_url}}\">Patakaran sa Palihim</a>",
      "Tinutulongang ilagay ang higit pang tunay na ikaw sa, <br />para sa pakiramdam mong maganda ang pagde-date.",
      "Narito ang pakipag-date na may kumpiyansa.",
      "O",
      "May account ka na?",
      "Magsign up gamit ng iyong email o numero ng telepono",
      "Kunin ang gusto mo sa pakikipag-date.{{__EOL__}}Hindi na kailangang humingi ng tawad.",
      "Gusto lang makipag-chat? OK lang iyon.{{__EOL__}}Handa ka na bang magpakatino? Gusto ko iyan.{{__EOL__}}{{__EOL__}}At kung sakaling magbago ang isip mo, tiyak na puwede.",
      "Narito makidate",
      "Handa para sa isang relasyon",
      "Bukas magchat",
      "Magtagpo ng mga taong gusto ang parehong bagay.",
      "{{name}}, {{age}}",
      "Ang kaligtasan mo ang aming numero unong priyoridad.",
      "Ang aming Sentro ng Kaligtasan, ay isang sentro ng kaalaman, na naglalalman ng lahat ng suportang kailangan mong makipag-date nang may kumpiyansa.",
      "Bisitahin aming Sentro ng Kaligtasan",
      "Kaligtasan una,<br/> pangalawa, at palagi.",
      "Mula sa unang sandali, naisip ko na ito ay gagana...",
      "Noong una, wala akong hinahanap na seryoso...",
      "Ang isang payo para sa sinuman sa Badoo App ay maging ang kanilang sarili...",
      "Mga Kuwento ng Tagumpay sa Badoo",
      "Tingnan ang marami pang mga kuwento ng tagumpay",
      "{{num}} __CUT__Marka",
      "Apple App Store",
      "Magtiwala ka sa amin. Pinagsama-sama namin ang milyun-milyon (at milyun-milyon, at milyon-milyong) na mga tao mula noong 2006.",
      "{{num}} M+__CUT__Downloads",
      "{{num}} M+",
      "Google Play Store",
      "Alam namin ang ginagawa namin.",
      "Mag-log in gamit ng iyong email o numero ng telepono",
      "Ipasok ang iyong password",
      "Nakalimutan ang password?",
      "Magsign up",
      "Wala kang account?",
      "Login",
      "Magsign up"
],

    // These are the common words found in the lexemes of the app
    common: {
      "characters": {
            "plural": [
                  "mga letra"
            ],
            "singular": [
                  "letra"
            ]
      },
      "day": {
            "plural": [
                  "mga araw"
            ],
            "singular": [
                  "araw"
            ]
      },
      "hour": {
            "plural": [
                  "mga oras"
            ],
            "singular": [
                  "oras"
            ]
      },
      "minute": {
            "plural": [
                  "mga minuto"
            ],
            "singular": [
                  "minuto"
            ]
      },
      "month": {
            "plural": [
                  "mga buwan"
            ],
            "singular": [
                  "buwan"
            ]
      },
      "second": {
            "plural": [
                  "mga segundo"
            ],
            "singular": [
                  "segundo"
            ]
      },
      "year": {
            "plural": [
                  "mga taon"
            ],
            "singular": [
                  "taon"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
